type ShouldShowTargetSelectorParams = {
  isTargetSelectorOpen: boolean;
  targetId: number | undefined;
  selectedTargetId: number | undefined;
  dismissedTargetId: number | undefined;
  hasEmptyQueryResult: boolean;
};

export function shouldShowTargetSelector({
  isTargetSelectorOpen,
  targetId,
  selectedTargetId,
  dismissedTargetId,
  hasEmptyQueryResult,
}: ShouldShowTargetSelectorParams): boolean {
  return (
    isTargetSelectorOpen ||
    (hasEmptyQueryResult && targetId !== undefined && targetId === selectedTargetId && targetId !== dismissedTargetId)
  );
}
